<template>
	<ul>
		<li v-for="recipe in recipes"
			v-bind:key="recipe.id">
			<a v-bind:href="'#/recipe/' + recipe.id">{{ recipe.value.name }}</a>
			<span v-if="showCategories"> ({{ recipe.value.category }})</span>
		</li>
	</ul>
</template>

<script>
	export default {
		props: {
			recipes: Array,
			showCategories: Boolean
		}
	}
</script>
